var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002178"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2615",
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "#5B5F62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.2019 17.809C20.021 17.7191 18.8455 17.1798 18.6647 17.0899C18.4838 17 18.303 17 18.1221 17.1798C17.9413 17.3596 17.5796 17.8989 17.3987 18.0787C17.3083 18.2584 17.1275 18.2584 16.9466 18.1685C16.3136 17.8989 15.6807 17.5393 15.1381 17.0899C14.686 16.6404 14.2339 16.1011 13.8722 15.5618C13.7818 15.382 13.8722 15.2022 13.9626 15.1124C14.053 15.0225 14.1435 14.8427 14.3243 14.7528C14.4147 14.6629 14.5052 14.4831 14.5052 14.3933C14.5956 14.3034 14.5956 14.1236 14.5052 14.0337C14.4147 13.9438 13.9626 12.8652 13.7818 12.4157C13.6914 11.7865 13.5105 11.7865 13.3297 11.7865H12.8775C12.6967 11.7865 12.4254 11.9663 12.335 12.0562C11.7925 12.5955 11.5212 13.2247 11.5212 13.9438C11.6116 14.7528 11.8829 15.5618 12.4254 16.2809C13.4201 17.7191 14.686 18.8876 16.2232 19.6067C16.6753 19.7865 17.037 19.9663 17.4891 20.0562C17.9413 20.236 18.3934 20.236 18.9359 20.1461C19.5689 20.0562 20.1114 19.6067 20.4731 19.0674C20.654 18.7079 20.654 18.3483 20.5636 17.9888L20.2019 17.809ZM22.4625 9.62921C18.9359 6.1236 13.2392 6.1236 9.71271 9.62921C6.81915 12.5056 6.27661 16.9101 8.26593 20.4157L7 25L11.7925 23.7416C13.1488 24.4607 14.5956 24.8202 16.0424 24.8202C21.0157 24.8202 24.9943 20.8652 24.9943 15.9213C25.0847 13.5843 24.0901 11.3371 22.4625 9.62921ZM20.021 22.2135C18.8455 22.9326 17.4891 23.382 16.0424 23.382C14.686 23.382 13.4201 23.0225 12.2446 22.3933L11.9733 22.2135L9.17017 22.9326L9.89356 20.236L9.71271 19.9663C7.54254 16.3708 8.62763 11.8764 12.1542 9.62921C15.6807 7.38202 20.2019 8.55056 22.372 11.9663C24.5422 15.4719 23.5475 20.0562 20.021 22.2135Z",
    fill: "#5B5F62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp_icon.65e76905ed22e40306c3a156fd1dc59b.svg";
export { ForwardRef as ReactComponent };